import moment from "moment";

export const generateUrl = (url) => {

    if(url.includes("/getRouteInfo")){
         return window.cdnUrl + url;
    }else{
       return window.url + url;
    }
}

export const GetRequest = async (url) => {
    try {
        const response = await fetch(generateUrl(url));
        try {
            return await response.json();
        } catch (error) {
            return false;
        }
    }
    catch (err) {
        return err;
    }
}

export const PostRequest = async (url, postData) => {
    let body = new FormData();
    Object.keys(postData).forEach(el => {
        body.append(el, typeof (postData[el]) === "string" ? postData[el] : JSON.stringify(postData[el]));
    })
    try {
        const response = await fetch(generateUrl(url), {
            method: "POST",
            body
        });
        try {
            return await response.json();
        } catch (error) {
            return false;
        }
    }
    catch (error) {
        return error;
    }

}

export function getSearchParams() {
    const myObj = {};
    const param = decodeURIComponent(window.location.search).split('?').length > 1 ? decodeURIComponent(window.location.search).split('?')[1] : false;
    const pairs = param.split('&');
    for (let i = 0; i < pairs.length; i++) {
        pairs[i] = pairs[i].split('=');
        myObj[pairs[i][0]] = pairs[i][1];
    }
    return myObj;
}

/* -------------- DATE FORMAT START -------------- */
/*
    t => date --- 09, 21 etc
    d => days in small --- Sun, Mon etc
    D => days in big --- Sunday, Monday etc
    m => months in small --- Jan, Feb etc
    M => months in big --- January, February etc
    y => years in small --- 19, 18 etc
    Y => years in big --- 2019, 2018 etc
    h => hours in 12 hrs format --- 01 - 12
    H => hours in 24 hrs format --- 09, 19 etc
    i => minutes --- 22, 03
    s => seconds --- 22, 03
    a => am/pm in small --- am, pm
    A => AM/PM in small --- AM, PM

*/
/* -------------- DATE FORMAT END -------------- */

export const monthsFull = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
export const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
export const daysFull = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
export const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
export const isLeapYr = (year) => (year || new Date().getFullYear()) % 4 === 0;
export const noOfDays = (year) => [31, (isLeapYr(year) ? 29 : 28), 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
export const monthDates = (month, year) => noOfDays(year)[month];
export const prefixZero = (val) => (val + "").length === 1 ? "0" + val : val;

export const getDaysInMonth = (month, year, param = 0) => {
    const days = [];
    const firstDay = new Date(year, month, 1).getDay() + param;
    for (let i = 0; i < firstDay; i++) {
        days.push(false);
    }
    const totalDays = monthDates(month, year);
    for (let i = 1; i <= totalDays; i++) {
        days.push(i);
    }
    return days;
}

export const getFormat = (date, format) => {
    date = new Date(date);
    if (!date) {
        return "Invalid date format";
    }
    let returnDate = "";
    format = format.split("");
    format.forEach(el => {
        returnDate += getFormatHelper(el, date);
    });
    return returnDate;
}

const getFormatHelper = (param, date) => {
    const day = date.getDay();
    const month = date.getMonth();
    const year = date.getFullYear();
    const hours = date.getHours();
    switch (param) {
        case "d":
            return days[day];
        case "D":
            return daysFull[day];
        case "m":
            return months[month];
        case "M":
            return monthsFull[month];
        case "y":
            return (year + "").substring(2, 4);
        case "Y":
            return year;
        case "h":
            return (hours > 12 ? prefixZero(hours - 12) : (hours === 0 ? 12 : prefixZero(hours)));
        case "H":
            return prefixZero(hours);
        case "i":
            const min = date.getMinutes();
            return prefixZero(min);
        case "s":
            const sec = date.getSeconds();
            return prefixZero(sec);
        case "a":
            return (hours >= 12 ? "pm" : "am");
        case "A":
            return (hours >= 12 ? "PM" : "AM");
        case "t":
            const dt = date.getDate();
            return prefixZero(dt);
        default:
            return param;
    }
}

export const getDateStringFromDMY = (day, month, year) => `${year}-${prefixZero(month + 1)}-${prefixZero(day)}`; // YYYY-MM-DD
export const getDateStringFromDate = (date) => getDateStringFromDMY(date.getDate(), date.getMonth(), date.getFullYear()); // YYYY-MM-DD
export const getIosFormattedDate = (datestr) => {
    if (datestr.indexOf("T") === -1) {
        datestr = datestr.split(" ").join("T");
    }
    datestr = datestr.split(/[^0-9]/);
    return new Date(datestr[0], datestr[1] - 1, datestr[2], datestr[3], datestr[4], datestr[5]);
}
export const getOtherDate = (date, param) => new Date(date.setDate(date.getDate() + param))
export const getRevDate = (date) => date.split("-").reverse().join("-");

export function getDur(dep, arr) {
    const diff = (Math.abs(new Date(arr) - new Date(dep))) / (1000 * 60);
    return Math.floor(diff / 60) + ':' + prefixZero(diff % 60) + 'hrs';
}

export function getSortedDur(dep, arr) {
    const diff = (Math.abs(new Date(arr) - new Date(dep))) / (1000 * 60);
    return diff;
}

export const handleImgError = (e) => {
    e.target.style = 'display:none'
}

export const getImgPath = (path) => window.imgPath + path;
export const getImgPath2 = (path) => window.imgPath2 + path;

const checkStorageSupported = () => {
    var test = 'test';
    try {
        localStorage.setItem(test, test);
        localStorage.removeItem(test);
        return true;
    } catch (e) {
        return false;
    }
}

export const isStorageSupported = checkStorageSupported();

export const storeToLocalStorage = (prop, value) => {
    if (isStorageSupported) {
        localStorage.setItem(prop, JSON.stringify(value));
    }
}

export const getFromLocalStorage = (prop) => {
    if (isStorageSupported) {
        var propValue = localStorage.getItem(prop);
        return propValue === null ? {} : JSON.parse(propValue);
    }
}

export const deleteItemFromStorage = (prop) => {
    if (isStorageSupported) {
        localStorage.removeItem(prop);
    }
}

export async function getIPAddress() {
    try {
        const response = await fetch('https://api.ipify.org/?format=json');
        const data = await response.json();
        return data.ip;
    } catch (error) {
        console.error('Error fetching IP address:', error);
        throw error; // Propagate the error
    }
}
export const getparamsString = (data) => {
    // Check if data is an object
    if (typeof data !== 'object' || data === null || Array.isArray(data)) {
        return ""; // Return empty string if data is not an object, null, or an array
    }

    let queryParams = "";
    Object.entries(data).forEach((entry, index, { length }) => {
        const [key, value] = entry;

        // Check if value is not an object, array, or null
        if (typeof value !== 'object' || value === null || Array.isArray(value)) {
            queryParams += `${key}=${encodeURIComponent(value)}&`; // Handle other data types by encoding them
        } else {
            if (index === length - 1) {
                queryParams += `${key}=${encodeURIComponent(JSON.stringify(value))}`;
            } else {
                queryParams += `${key}=${encodeURIComponent(JSON.stringify(value))}&`;
            }
        }
    });
    return queryParams;
};

export const focusElemnt = (elementID) => {
    elementID && document.getElementById(elementID) && document.getElementById(elementID).focus()
}

export const getYearList = (range = 1950) => {
    const currentYear = new Date().getFullYear();
    const yearsArray = [];
    for (let year = currentYear; year >= range; year--) {
        yearsArray.push({ id: currentYear - year, name: year.toString() });
    }
    return yearsArray;
};

export const maskIdCard = (idCardNumber) => {
    if (idCardNumber && idCardNumber.length > 4) {
        const lastFourDigits = idCardNumber.slice(-4);
        const maskedDigits = 'x'.repeat(idCardNumber.length - 4);
        return maskedDigits + lastFourDigits;
    } else {
        return idCardNumber;
    }
}


export const getPassengerType = (val) => {
    let passengerType = "";
    if (val > 0) {
        if (val <= 11) {
            passengerType = "Child";
        } else {
            passengerType = "Adult";
        }
    }
    return passengerType;
};
export const getPassengerGender = (genderCode) => {
    if (!genderCode) return "";
    const lowerCaseGenderCode = genderCode.toLowerCase();
    switch (lowerCaseGenderCode) {
        case "m":
            return "Male";
        case "f":
            return "Female";
        case "o":
            return "Other";
        default:
            return "";
    }
};

const getCurrentDate = () => {
    const today = new Date();
    const dd = String(today.getDate()).padStart(2, "0");
    const mm = String(today.getMonth() + 1).padStart(2, "0"); // January is 0!
    const yyyy = today.getFullYear();

    return `${dd}-${mm}-${yyyy}`; //DD-MM-YYYY
};

export const bookAgain = (data) => {
    const todayDate = getCurrentDate();
    let fromCity = data?.FromCityName.toLowerCase();
    fromCity = fromCity.charAt(0).toUpperCase() + fromCity.slice(1);

    let toCity = data?.ToCityName.toLowerCase();
    toCity = toCity.charAt(0).toUpperCase() + toCity.slice(1);

    let redirectUrl = `/search?mode=oneway&fromCity=${data.FromCityID}|${fromCity}&toCity=${data.ToCityID}|${toCity}&departDate=${todayDate}&src=h&stationInFromCity=&stationInToCity=`;
    window.open(redirectUrl, '_blank');
    //window.location.href = redirectUrl;
};

export const LAST_SEARCH_URL_KEY = "ksrtcLastSearchUrl";

export const saveLastSearchUrl = (url) => {
    if (!isStorageSupported) return;
    try {
        const value = url || `${window.location.pathname || ""}${window.location.search || ""}`;
        if (value.indexOf("/search") === -1) return;
        const query = value.indexOf("?") >= 0 ? value.slice(value.indexOf("?") + 1) : "";
        const params = new URLSearchParams(query);
        if (!params.get("fromCity") || !params.get("toCity") || !params.get("departDate")) return;
        localStorage.setItem(LAST_SEARCH_URL_KEY, value);
    } catch (err) {
        // ignore storage failures
    }
};

export const getLastSearchUrl = () => {
    if (!isStorageSupported) return "";
    try {
        return localStorage.getItem(LAST_SEARCH_URL_KEY) || "";
    } catch (err) {
        return "";
    }
};

export const convertTimeTo12HourFormat = (time24) => {
    // Extract hours and minutes from the time string
    const [hours, minutes] = time24.split(':').map(Number);

    // Determine AM or PM
    const period = hours >= 12 ? 'PM' : 'AM';

    // Convert hours to 12-hour format
    const hours12 = (hours % 12) || 12;

    // Format the time
    const formattedTime = `${hours12.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')} ${period}`;

    return formattedTime;
}

var interval
export const countdown = (element, minutes, seconds, setValue) => {
    var time = minutes * 60 + seconds;
    interval = setInterval(function () {
        var el = document.getElementById(element);
        if (time <= 0) {
            setValue("Resend")
            clearInterval(interval);
            return;
        }
        var minutes = Math.floor(time / 60);
        if (minutes < 10) minutes = "0" + minutes;
        var seconds = time % 60;
        if (seconds < 10) seconds = "0" + seconds;
        var text = minutes + ':' + seconds;
        if (el)
            el.innerHTML = text;
        time--;
    }, 1000);
}

export function stopTimer() {
    clearInterval(interval);
    // GO RIGHT;
}

export function customSort(a, b) {

    const regex = /(\d+|\D+)/g;

    const chunksA = a.toString().match(regex);
    const chunksB = b.toString().match(regex);

    for (let i = 0; i < Math.min(chunksA.length, chunksB.length); i++) {

        const chunkA = chunksA[i];
        const chunkB = chunksB[i];

        const isNumericA = !isNaN(chunkA);
        const isNumericB = !isNaN(chunkB);

        if (isNumericA && isNumericB) {
            // Compare numbers numerically
            const numA = parseInt(chunkA, 10);
            const numB = parseInt(chunkB, 10);

            if (numA !== numB) {
                return numA - numB;
            }
        } else if (isNumericA) {
            // Numeric chunks come before alphabetic chunks
            return -1;
        } else if (isNumericB) {
            // Alphabetic chunks come after numeric chunks
            return 1;
        } else {
            // Compare alphabetic chunks lexicographically
            if (chunkA !== chunkB) {
                return chunkA.localeCompare(chunkB);
            }
        }
    }

    // If all chunks compared equal so far, the longer string should come later
    return chunksA.length - chunksB.length;
}
export function get24HoursDateTimeForFB(val) {
    var date = new Date(val);
    return moment(date, 'YYYY-MM-DD hh:mm:ss a').format("HH:mm, ddd DD MMM");
}

export function getDateFormatIPhone(val, format) {

    // console.log('input', val);

    var [date, time, meridiem] = val.split(" ");
    var [year, month, day] = date.split("-");
    var [hour, min, sec] = time.split(":");
    sec = parseInt(sec) > 0 ? sec : "00";

    if (meridiem.toLowerCase() == 'pm' && parseInt(hour) != 12) {
        hour = +hour + 12;
    }

    var newDate = new Date(+year, +month - 1, +day, +hour, +min, +sec);

    //console.log('output',moment(newDate, 'YYYY-MM-DD hh:mm:ss a').format(format));

    return moment(newDate, 'YYYY-MM-DD hh:mm:ss a').format(format);
}

export function getDateFormatIPhone2(val, format) {

    // console.log('input', val);

    var [date, time, meridiem] = val.split(" ");
    var [month, day, year] = date.split("/");
    var [hour, min, sec] = time.split(":");
    sec = parseInt(sec) > 0 ? sec : "00";

    if (meridiem.toLowerCase() == 'pm' && parseInt(hour) != 12) {
        hour = +hour + 12;
    }

    // console.log({ year, month, day })

    var newDate = new Date(+year, +month - 1, +day, +hour, +min, +sec);

    //console.log('output',moment(newDate, 'YYYY-MM-DD hh:mm:ss a').format(format));

    return moment(newDate, 'YYYY-MM-DD hh:mm:ss a').format(format);
}

export const PostRequestForIOS = async (url, postData) => {
    try {
        const response = await fetch(generateUrl(url), {
            method: "POST",
            body: postData,
        });
        try {
            return await response.text();
        } catch (error) {
            return false;
        }
    }
    catch (error) {
        return error;
    }
}

export const randomString = (length) => {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * characters.length));
    }
    return result;
}

export const generateCaptchaToken = async (siteKey) => {
    if (window.grecaptcha && typeof window.grecaptcha.execute === 'function') {
        try {
            const token = await window.grecaptcha.execute(siteKey, { action: 'submit_form' });
            // console.log('Generated Token:', token);
            return token; // Use the token for further processing
        } catch (error) {
            console.error('Error executing reCAPTCHA:', error);
            return randomString(12);
        }
    } else {
        // console.error('reCAPTCHA execute function is unavailable');
        return randomString(12);
    }
};

export const verifyCaptchaToken = async (token) => {

    const data = {
        response: token
    };

   // setLoader(true)

    return PostRequest('/api/resource/validateCaptcha', data)
        .then((res) => {
            if (res.Success) {
                //setLoader(false);
                return true;
            } else {
                //setLoader(false);
                return false;
            }
            //return res;
        })
        .catch((err) => {
            //setLoader(false);
            return false;
        });
};